import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import type { WebClientUser } from '../../types/WebUser';

const initialState: WebClientUser = {
  uid: '',
  authProvider: 'token',
  isAnonymous: true,
  isInitialVisit: true,
  visitorId: '',
  sessionInfo: {
    visitId: '',
    sessionId: '',
    startTimestamp: 0,
  },
};

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    initializeUser: (_, action: PayloadAction<WebClientUser>) => {
      return action.payload;
    },
    updateUser: (state, action: PayloadAction<Partial<WebClientUser>>) => {
      return { ...state, ...action.payload };
    },
    setIsChangingAuthToken: (state, action: PayloadAction<boolean>) => {
      state.isChangingAuthToken = action.payload;
    },
  },
});

export const { initializeUser, updateUser, setIsChangingAuthToken } = userSlice.actions;
